
import { userDataSet } from 'store/userData';
import { useDispatch } from 'react-redux';

export function useClientStateDataUpdate() {
  const dispatch = useDispatch();
  const updateClientStateData = (clientStateData, journeyGUID, processGUID, identity) => {
    //RC add null update
    dispatch(
      userDataSet({// data from journeyconfiguration
        ...(journeyGUID && { journeyGUID: journeyGUID }),
        ...(processGUID && { processGUID: processGUID }),
        ...(identity && { identity: identity }),
        // data from clientStateData, (all other responses) 
        ...(clientStateData?.customerGUID && { clientStateData: { customerGUID: clientStateData.customerGUID, ...clientStateData } }),
        ...(clientStateData?.selectedDate && { clientStateData: { selectedDate: clientStateData.selectedDate, ...clientStateData } }),
        ...(clientStateData?.selectedSlot && { clientStateData: { selectedSlot: clientStateData.selectedSlot, ...clientStateData } }),
        ...(clientStateData?.lngCode && { clientStateData: { lngCode: clientStateData.lngCode, ...clientStateData } }),
        ...(clientStateData?.calendarIds && { clientStateData: { calendarIds: clientStateData.calendarIds, ...clientStateData } }),
        ...(clientStateData?.questionAnswerDict && { clientStateData: { questionAnswerDict: clientStateData.questionAnswerDict, ...clientStateData } }),
        ...(clientStateData?.serviceTypeId && { clientStateData: { serviceTypeId: clientStateData.serviceTypeId, ...clientStateData } }),
        ...(clientStateData?.appointmentTypeId && { clientStateData: { appointmentTypeId: clientStateData.appointmentTypeId, ...clientStateData } }),
        ...(clientStateData?.unitId && { clientStateData: { locationId: clientStateData.unitId, ...clientStateData } }),
        ...(clientStateData?.serviceId && { clientStateData: { serviceId: clientStateData.serviceId, ...clientStateData } }),
      })
    );
  };
  return updateClientStateData;
}